export enum DialogDimension {
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
}

export interface DialogSize {
  height?: DialogDimension | number;
  width?: DialogDimension | number;
}

/**
 * Properties shared between a URL based and an Adaptive Card based Dialogs
 */
interface DialogProps extends DialogSize {
  title?: string;
  fallbackUrl?: string;
  completionBotId?: string;
}

/**
 * Describes the data received from App SDK, which can be either a URL-based or an Adaptive Card based Dialog
 */
export interface DialogInfo extends DialogProps {
  url?: string;
  card?: string;
}

export enum DialogContentType {
  Card = 'card',
  Url = 'url',
}

/**
 * Base of a discriminated union between a URL based and an Adaptive Card based Dialog info
 */
interface DialogBase<T extends DialogContentType> extends DialogProps {
  type: T;
}

/**
 * URL based Dialog info
 */
export interface DialogWithUrl extends DialogBase<DialogContentType.Url> {
  url: string;
}

export interface DialogWithAdaptiveCard extends DialogBase<DialogContentType.Card> {
  card: string;
}

export type Dialog = DialogWithUrl | DialogWithAdaptiveCard;

export interface IDialogService {
  open(dialog: Dialog): Promise<string | object>;
  resize(size: DialogSize): Promise<void>;
  submit(result?: string | object, appIds?: string[]): Promise<void>;
}
